import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const getAI = async (mode, prompt, value) => {
  if(!mode || !prompt || !value){
    return false
  }
  
  const apiURL = API_HOST + '/ai?type='+String(mode)+'&promptType='+String(prompt)+'&prompt='+value;
  console.log('apiURL')
  console.log(apiURL)
  const { token, userID } = ''; //useCurrentUser();
  try {
    const { data } = await axios.get(apiURL,{
      headers: {
        'Authorization': 'Bearer '+token,
        'x-sb-user-id': userID
      }
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
